exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-wrap[data-v-309ba75c] {\n  margin-bottom: 25px;\n}\n.search-area[data-v-309ba75c] {\n  margin-bottom: 25px;\n}\n.pagination-wrap[data-v-309ba75c] {\n  text-align: right;\n  padding: 30px 20px;\n}\n.app-info[data-v-309ba75c] .el-tag--dark.el-tag--success {\n  background-color: #319579;\n  border-color: #2e9779;\n  color: #fff;\n}\n.wx-component-info[data-v-309ba75c] .el-tag--dark.el-tag--warning {\n  background-color: #237e93;\n  border-color: #14788e;\n  color: #fff;\n}\n.wx-component-show[data-v-309ba75c] {\n  width: 375px;\n}\n", ""]);

// exports
